import { render, staticRenderFns } from "./ThirdCard.vue?vue&type=template&id=54d129bd&scoped=true&"
import script from "./ThirdCard.vue?vue&type=script&lang=js&"
export * from "./ThirdCard.vue?vue&type=script&lang=js&"
import style0 from "./ThirdCard.vue?vue&type=style&index=0&id=54d129bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d129bd",
  null
  
)

export default component.exports